import { useNavigate } from 'react-router-dom'
import BackIcon from '../Icons/BackIcon'

const ButtonBack = ({ handler = null, disabled = false, title = 'Назад', to = '' }) => {
  const navigate = useNavigate()
  const defaultHandler = () => {
    if (to) navigate(to)
    else navigate('..')
  }

  return (
    <button
      onClick={handler || defaultHandler}
      disabled={disabled}
      className="btn btn_back"
      type="button"
    >
      <BackIcon />
      {title}
    </button>
  )
}

export default ButtonBack
